export const VILUU_CONSENT_STORAGE_KEY = 'viluu_consent_v1';
export const VILUU_CONSENT_STORAGE_VERSION = 1;
export const VILUU_CONSENT_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 180; // 180 days

/** True when the user opted into any non-essential category. */
export function viluuHasNonEssentialConsent(record) {
  return !!(record && (record.functional || record.statistics || record.marketing));
}

export function viluuParseConsentCookie(raw) {
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch (e) {
    return null;
  }
}

export function viluuReadConsentFromCookie(getCookie, key = VILUU_CONSENT_STORAGE_KEY) {
  return viluuParseConsentCookie(getCookie(key));
}
